import React from 'react';
import { Link } from 'react-router-dom';

const UploadVideo = () => {
	return (
		<div>
			<h2>Upload a Video</h2>
			<p>This section will go over how to upload and attach a video to a post using the Dynamic Signal API and AWS. This is a three-step process that includes getting a URL and ticket, uploading the video file to AWS, and then completing the process by sending the post relevant information.</p>

			{/* Relevant Endpoints */}
			<h3>Relevant Endpoints</h3>
			<p>There are three endpoints used in the process of uploading a video:</p>

			<h4>1. <Link to="/api/Posts#post-post-id-startvideo">POST /v1/post/{'{id}'}/startvideo</Link></h4>
			<h4>2. <strong>PUT Request to AWS URL Generated by /v1/post/startvideo</strong></h4>
			<h4>3. <Link to="/api/Posts#post-post-id-completevideo">POST /v1/post/{'{id}'}/completevideo</Link></h4>

			{/* Process */}
			<h3>Step-by-Step Process</h3>
			<h4>Step 1</h4>
			<p>Send a POST call to <em>/v1/post/{'{id}'}/startvideo</em> with the ID of the post you want to upload a video to. You must include the contentType field in the body because this is used and validated by AWS.</p>

			<h5>Example Request:</h5>
			<pre className="language-javascript"><code className="language-javascript">{`{
	"content-Type": "video/mp4"
}`}</code></pre>

			<p>The response object will include <strong>URL</strong> and <strong>Ticket</strong> strings. The URL is the AWS URL you will upload the video file to, and the ticket will be used by <em>/v1/post/{'{'}id{'}'}/completevideo.</em></p>

			<h5>Example Response Object:</h5>
			<pre className="language-javascript"><code className="language-javascript">{`{
  "url": "https://ds-dev-video-input.s3-us-west-2.amazonaws.com/317701/a2e3fab0-b91d-4d05-aa1b-b13483c4077e-4cead954-b01a-47b0-8271-ebb9d48db669?AWSAccessKeyId=ZZZZZZZZZZZZZZZZ&Expires=1495234419&Signature=ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  "ticket": "4cead954-b01a-47b0-8271-ebb9d48db669"
}`}</code></pre>

			<h4 id="uploadvideostep2">Step 2</h4>
			<p>Make a PUT request to the URL returned from <em>/v1/post/{'{id}'}/startvideo</em>. Include the video file you want to upload as a binary upload. This call must have <strong>Content-Type</strong> and <strong>Content-Length</strong> headers. Content-Type <em>must</em> be the same as the <strong>contentType</strong> previously entered in /v1/post/{'{id}'}/startvideo. If the upload is successful, it will retturn a 200 OK response with an empty body.</p>

			<h4 id="uploadvideostep3">Step 3</h4>
			<p>Once the upload is completed, make a POST call to <em>/v1/post/{'{id}'}/completevideo</em>. This notifies the platform that the video has been successfully uploaded and will start the process of attaching the video to the post and making it available to members. The body must include the <strong>ticket field</strong> using the ticket string previously returned from <em>/v1/post/{'{id}'}/startvideo</em>. It must also contain the <strong>mimeType</strong> field, which should be the same as the content-type entered in the startvideo and AWS upload calls. Optional information may also be included such as: width, height, and duration.</p>

			<h5>Example Request Object</h5>
			<pre className="language-javascript"><code className="language-javascript">{`{
	"ticket": "9cd96316-ba03-4496-8ac4-e9450a26bc1c",
	"mimeType": "video/mp4",
	"width": 100,
	"height": 200,
	"duration": 9001
}`}</code></pre>
			<p>If the call is successful, a 200 OK response will be returned with a success code. The video may not display immediately on the post, as it may take a short time to finish processing</p>
		</div>
	);
};

export default UploadVideo;


// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/UploadVideo.js